import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/live-ar-training"
    path="business/products/live-ar-training"
    element={<AsyncPage />}
  />,
];
